import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { trigger, style, animate, transition, AnimationEvent, query, stagger } from '@angular/animations';
import { MatIcon } from '@angular/material/icon';
import { PaintDirective } from '../../paint.directive';
import { MetaService } from '../../meta.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  imports: [MatIcon, PaintDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeUp', [
      transition(':enter', [
        query(
          'div',
          [
            style({
              opacity: 0, 
              transform: 'translateY(50px) scale(0.9, 0.9)' 
            }),
            stagger(400, [
              animate('350ms cubic-bezier(0.455, 0.03, 0.515, 0.955)', style({
                opacity: 1, 
                transform: 'translateY(0px) scale(0.9, 0.9)' 
              }))
            ]),
          ],
          {optional: true},
        )
      ]),
    ]),
  ]
})
export default class AboutUsComponent {
  position: number[] = Array(4).fill(0);
  current: number = 0;
  meta = inject(MetaService);

  constructor(){
    this.meta.setTags('cloudigo Malta - About Us');
    afterNextRender(() => {
      this.position[0] = 1;
    })
  }

  toggleState(event: AnimationEvent){
    if(!this.meta.isBrowser) return;

    const caller: string = event.element.attributes.getNamedItem('paint').value;
    
    let val = -1;
    // console.log(caller)
    switch(caller){
      case 'accent': val = 1; break;
      case 'primary': val = 2; break;
    }

    if(val != -1 && this.position[val-1]){
      setTimeout(() => {
        this.position[val] = 1
        if(val == 2)
          this.position[3] = 1;
      }, 500);
    }
  }

}
